<script>
import { mapActions, mapGetters, mapState } from "vuex";

import Addresses from "./Addresses";
import SelectedAddress from "./SelectedAddress";
import CancelOrderOffer from "../ProfessionalOfferList/CancelOrderOffer";

export default {
  components: {
    Addresses,
    SelectedAddress,
    CancelOrderOffer
  },

  data() {
    return {
      open: false
    };
  },

  methods: {
    ...mapActions("orderScheduler", ["cancelOrderOffer"]),

    toogleAddressSelection() {
      if (
        this.orderOfferEnable &&
        this.orderOfferExpired &&
        !this.avaliableProfessionals.length
      ) {
        this.handleCancelOrderOffer();
      }

      this.open = !this.open;
    },

    handleCancelOrderOffer() {
      this.cancelOrderOffer();
    }
  },

  computed: {
    ...mapState("addresses", ["addresses", "preloader"]),
    ...mapState("orderScheduler", [
      "selectedAddress",
      "orderOfferEnable",
      "orderOfferExpired"
    ]),
    ...mapGetters("orderScheduler", [
      "address",
      "searchOrderOfferProfessionals",
      "avaliableProfessionals"
    ])
  },

  mounted() {
    if (!this.address) {
      this.toogleAddressSelection();
    }
  },

  watch: {
    // Watcher used to close the addresses list when an address is selected
    // after its creation.
    selectedAddress(newAddress) {
      if (newAddress && this.open) {
        this.open = false;
      }
    }
  }
};
</script>

<template>
  <div class="address-content">
    <div class="selection" @click="toogleAddressSelection">
      <span class="header" :class="{ 'header-selected': address }">Endereço</span>

      <span class="detail" v-if="!address">Onde você precisa de limpeza?</span>

      <SelectedAddress v-else :address="address" />
    </div>

    <CancelOrderOffer
      v-if="open && searchOrderOfferProfessionals"
      @closeCancelOrderOfferModal="toogleAddressSelection"
      @cancelOrderOffer="handleCancelOrderOffer"
    />

    <Addresses v-else-if="open" @addressSelection="toogleAddressSelection" />
  </div>
</template>

<style scoped>
.address-content {
  width: 100%;
  position: relative;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  user-select: none;
  cursor: pointer;
  background: #fff;
}

.selection {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
}

.header {
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 400;
  color: #424242;
}

.header-selected {
  color: #888;
  font-weight: 300;
}

.detail {
  font-size: 15px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Address/Index.vue